module.exports = __webpack_public_path__ + "img/移动优秀合作伙伴.0c044561.jpg";